import Roles from "../../configs/Roles";

const titles = {
    ACTIVEUSERS: 'ActiveUsers',
};

export const ActiveUsers = [
    {
        icon: 'UserNavSvgIcon',
        component: 'ActiveUsers',
        path: '/vpn-users',
        title: titles.ACTIVEUSERS,
        key: 'activeuser',
        menu: 'VPN Users',
        parent: true,
        // permission:[Roles.RESELLER]
    },
    {
        component: 'DetailVPNAccount',
        path: '/vpn-users/detail/:id',
        title: titles.ACTIVEUSERS,
        key: 'activeuser',
        menu: 'VPN Users',
        parent: false,
        permission:[Roles.RESELLER]
    },
    {
        component: 'ManageVPNAccount',
        path: '/vpn-users/manage/:id',
        title: titles.ACTIVEUSERS,
        key: 'activeuser',
        menu: 'VPN Users',
        parent: false,
        permission:[Roles.RESELLER]
    },
];
